import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useResultsV2Store } from "@stores/survey/resultsV2/resultsV2";

/**
 * Composable that merges global view options with card-level local_options.
 * Local options override global ones.
 */
export function useCardOptions(card) {
  const store = useResultsV2Store();
  const { currentView } = storeToRefs(store);

  const mergedOptions = computed(() => {
    const globalOptions = currentView.value?.options || {};
    const localOptions = card.value?.options || {};
    return { ...globalOptions, ...localOptions };
  });

  return { mergedOptions };
}
